// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1SJZn","cell":"ColumnAccessor_cell__395YB","firstCellAccent":"ColumnAccessor_firstCellAccent__3WGqt"};